export const TYPES = {
  UserRouter: Symbol.for('UserRouter'),
  UserDao: Symbol.for('UserDao'),
  UserStateRepository: Symbol.for('UserStateRepository'),
  UserUseCases: Symbol.for('UserUseCases'),
  UserAPIService: Symbol.for('UserApiService'),
};
